var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$user)?_c('div',{staticClass:"flex h-full"},[_c('SideBar',{staticClass:"side-bar h-screen sticky top-0"}),_c('div',{staticClass:"content"},[_c('NavbarTop'),_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }